/** Estimated wait time shown in analysis loading UI. */
export const ANALYSIS_ESTIMATED_SECONDS = 30;

/** Client-side HTTP timeout — slightly longer than backend limit. */
export const ANALYSIS_TIMEOUT_MS = 95000;

/** Upload timeout — slightly longer than backend UPLOAD_TIMEOUT_SECONDS. */
export const UPLOAD_TIMEOUT_MS = 305000;
